import { isNil, find } from 'lodash-es'
import { api } from '@/api'
import to from '@/modules/await-to-js'

const state = {
  capabilities: {}
}

export const getters = {
  capabilities: state => state.capabilities,
  bscFeature: state => (gateway, feature) => {
    // Return true by default
    const defaultReturn = true

    if (!gateway.brand) return defaultReturn

    const bsc = find(state.capabilities, bsc => gateway.brand.name === bsc.brand)
    if (!bsc) return defaultReturn

    return isNil(bsc.capabilities[feature]) ? defaultReturn : bsc.capabilities[feature]
  },
  gatewayFeature: state => (gateway, feature) => {
    // Return true by default
    const defaultReturn = true

    if (!gateway.brand || !gateway.description) return defaultReturn

    const bsc = find(state.capabilities, bsc => gateway.brand.name === bsc.brand)
    if (!bsc) return defaultReturn

    const features = find(bsc.capabilities.features, (gatewayFeatures, brand) => gateway.description.toLowerCase().indexOf(brand.toLowerCase()) !== -1)
    if (!features) return defaultReturn

    return isNil(features[feature]) ? defaultReturn : features[feature]
  }
}

export const mutations = {
  setCapabilities (state, capabilities) {
    state.capabilities = capabilities
  }
}

export const actions = {
  async getCapabilities (context) {
    let error, response
    [error, response] = await to(api.getCapabilities(context.rootGetters.application))
    if (error || !response) return Promise.reject(error)

    context.commit('setCapabilities', response.data)
    return Promise.resolve(response)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
